import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'menu-tabs',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
    @Output('show') show = new EventEmitter();
    @Input('list') list;
    constructor() { }

    ngOnInit() {
    }

    showChildren(cod){
        this.show.emit(cod);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/menu/menu.component.ts